import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { createAutomation } from "./schema/create-automation";
import { deleteAutomation } from "./schema/delete-automation";
import { explore } from "./schema/explore";
import { getAutomation } from "./schema/get-automation";
import { getCatalog } from "./schema/get-catalog";
import { getRun } from "./schema/get-run";
import { getVersion } from "./schema/get-version";
import { listAutomations } from "./schema/list-automations";
import { listRuns } from "./schema/list-runs";
import { listVersions } from "./schema/list-versions";
import { previewPublish } from "./schema/preview-publish";
import { publish } from "./schema/publish";
import { restoreVersion } from "./schema/restore-version";
import { runNow } from "./schema/run-now";
import { saveDraft } from "./schema/save-draft";
import { setActive } from "./schema/set-active";
import { setVersionStrategy } from "./schema/set-version-strategy";
import { simulate } from "./schema/simulate";
import { validate } from "./schema/validate";

export const rpcDefinition = {
  listAutomations,
  getAutomation,
  createAutomation,
  saveDraft,
  previewPublish,
  publish,
  setActive,
  setVersionStrategy,
  deleteAutomation,
  listVersions,
  getVersion,
  restoreVersion,
  validate,
  simulate,
  explore,
  getCatalog,
  listRuns,
  getRun,
  runNow,
};

export type RedoAutomationsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
